import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import InfoIcon from '@mui/icons-material/Info';
import { ProductMessageText } from './ProductSelectionStyles';
import { useCallback } from 'react';

const ProductMessagesComponent = ({ warnings }) => {
  const getIcon = useCallback(messageTypeId => {
    switch (messageTypeId) {
      case 1:
        return <WarningRoundedIcon color='warning' />;
      case 2:
        return <ErrorIcon color='error' />;
      case 4:
      default:
        return <InfoIcon color='primary'></InfoIcon>;
    }
  }, []);

  const getTextColor = useCallback(messageTypeId => {
    switch (messageTypeId) {
      case 1:
        return 'warning';
      case 2:
        return 'error';
      case 4:
      default:
        return 'primary';
    }
  }, []);

  return (
    <Grid container flexDirection='column' gap={1}>
      {warnings.map((n, index) => {
        return (
          <Grid container key={index} alignItems='center' gap={1}>
            {getIcon(n.messageType)}
            <ProductMessageText color={getTextColor(n.messageType)}>{n.message}</ProductMessageText>
          </Grid>
        );
      })}
    </Grid>
  );
};

ProductMessagesComponent.propTypes = {
  warnings: PropTypes.array
};
export default ProductMessagesComponent;
